import { useNavigate } from 'react-router-dom';
import { useAuth } from 'wasp/client/auth';
import { routes } from 'wasp/client/router';

export function NotFoundPage() {
  const { data: user } = useAuth();
  const navigate = useNavigate();

  const handleGoBack = () => {
    // Prefer browser history (e.g. back to /bayviewyards/food-court)
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate(user ? routes.DashboardRoute.to : routes.LandingPageRoute.to);
  };

  return (
    <div className='flex flex-col items-center justify-center min-h-[calc(100vh-var(--header-height))] px-4 text-center'>
      <div className='relative'>
        <h1 className='text-9xl font-black text-primary/10 select-none'>404</h1>
        <div className='absolute inset-0 flex flex-col items-center justify-center'>
          <h2 className='text-3xl font-bold text-foreground mb-2'>Page Not Found</h2>
          <div className='h-1 w-12 bg-primary rounded-full mb-6'></div>
        </div>
      </div>
      <p className='text-muted-foreground text-lg mb-10 max-w-md'>
        The resource you are looking for might have been removed, had its name changed, or is temporarily unavailable.
      </p>
      <button
        type='button'
        onClick={handleGoBack}
        className='inline-flex items-center justify-center px-8 py-3 text-base font-semibold text-primary-foreground bg-primary rounded-2xl hover:bg-primary/90 hover:scale-105 transition-all duration-300 shadow-lg shadow-primary/25'
      >
        Go Back
      </button>
    </div>
  );
}
